<template>
    <section
        :class="[
            { 'l-section--hero' : hero },
            { 'js-reveal' : reveal }
        ]"
        :wave="wave"
        class="l-section"
    >
        <span
            ref="sectionBg"
            class="l-section__bg"
            v-view.once="animateIn"
        ></span>
        <span
            v-if="bg"
            class="l-section__bg-img"
            v-view.once
        >
            <Img
                :data-src="bg.url"
                :alt="bg.title"
                :width="bg.width"
                :height="bg.height"
            />
        </span>
        <slot name="img" v-else-if="$slots.img"></slot>
        <div class="l-grid" :class="{'full-width': fullWidth}">
            <div class="l-section__inner">
                <slot/>
            </div>
        </div>
        <Wave v-if="wave"/>
    </section>
</template>

<script>
import Img from 'templates/objects/Img';
import Wave from 'templates/objects/Wave';

export default {
    name: 'Section',
    components: {
        Img,
        Wave,
    },
    data: () => ({
        currentColor: {},
    }),
    props: {
        hero: {
            type: Boolean,
            default: false,
        },
        color: {
            type: Object,
        },
        bg: {
            type: Object,
            default: null,
        },
        wave: {
            type: Boolean,
            default: false,
        },
        reveal: {
            type: Boolean,
            default: false,
        },
        fullWidth:{
             type: Boolean,
            default: false,
        }
    },
    methods: {

        animateIn() {
            this.setColors(this.color);
        },

        setColors(colors, duration = 1) {
            if (typeof colors === 'undefined') return;
            if (typeof colors.color === 'undefined') return;
            if (!colors.color) return;

            colors = colors.color.split(', ');

            this.currentColor.underline = colors[0];
            this.currentColor.bg = colors[1];

            if (this.hero) {
                TweenLite.to(document.querySelector('.l-wrapper'), duration, {
                    '--color-main': this.currentColor.underline,
                    '--color-light': this.currentColor.bg,
                    ease: Sine.easeOut,
                });
            } else {
                TweenLite.to(this.$el, duration, {
                    '--color-underline': this.currentColor.underline,
                    ease: Sine.easeOut,
                });

                TweenLite.to(this.$refs.sectionBg, duration, {
                    '--color-bg': this.currentColor.bg,
                    ease: Sine.easeOut,
                });
            }
        },
    },
    mounted() {
        if (this.hero || !this.reveal) {
            this.setColors(this.color);
        }
        // if(!this.reveal) {
        // this.setColors(this.color, 0)
        // }
    },
};
</script>
